// extracted by mini-css-extract-plugin
export default {"button":"Button_button__nItE3","outline":"Button_outline__kM1U7"};